export const messages = {
  en: {
    printPayFee: {
      apply: 'Application',
      receipt: 'Receipt voucher',
      refund: 'Refund',
      owner: 'Customer Name',
      receiptNum: 'Receipt No.',
      payTime: 'Payment Time',
      serialNumber: 'No.',
      feeItem: 'Fee Item',
      houseCar: 'Room number',
      feeRange: 'Fee Period',
      to: 'to',
      none: 'None',
      unitPrice: 'Unit Price',
      areaUsage: 'Floor area',
      paymentMethod: 'Payment Method',
      receivableActual: 'Receivable/Actual',
      yuan: 'yuan',
      discountAmount: 'Discount Amount',
      remark: 'Remark',
      capitalRMB: 'Capital RMB',
      accountDeduction: 'Account Deduction',
      departmentHead: 'Department Head:',
      operator: 'Payee',
      financeReceipt: 'Finance Receipt:',
      customerConfirm: 'Customer Confirm:',
      hz: 'Approve：',
      kj: 'Accounting：',
      jz: 'Bookkeeping：',
      cn: 'Cashier：'
    }
  },
  zh: {
    printPayFee: {
      apply: '申请单',
      receipt: '收款凭证',
      refund: '退款单',
      owner: '客户名称',
      receiptNum: 'NO',
      payTime: '收款时间',
      serialNumber: '编号',
      feeItem: '收费项目',
      houseCar: '房号',
      feeRange: '费用期间',
      to: '至',
      none: '无',
      unitPrice: '单价',
      areaUsage: '房屋面积',
      paymentMethod: '收款方式',
      receivableActual: '应收/实收',
      yuan: '元',
      discountAmount: '优惠金额',
      remark: '备注',
      capitalrmb: '金额（小写）',
      capitalRMB: '金额（大写）',
      accountDeduction: '账户扣款',
      departmentHead: '部门负责人：',
      operator: '收款人：',
      financeReceipt: '财务收款：',
      customerConfirm: '客户确认：',
      hz: '核准：',
      kj: '会计：',
      jz: '记账：',
      cn: '出纳：'
    }
  }
}